import { SubscriptionStatus } from '@showbie-socrative/socrative-utils';
import { useAtomValue } from 'jotai';

import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { useTeams } from '~teacher/hook/team';

export function useIsTrialing() {
  const selectedTeamId = useAtomValue(selectedTeamIdAtom);
  return useTeams({
    select: (teams) =>
      teams.find((team) => team.id === `${selectedTeamId}`).subscription
        ?.status === SubscriptionStatus.Trialing,
    enabled: !!selectedTeamId,
  });
}
